import { ArrowLeft, Map, MapPinned } from "lucide-react";
import { Drawer, DrawerContent } from "./ui/drawer";

function openExternalUrl(url) {
  window.location.href = url;
}

export default function DirectionsAppSheet({ destination, onOpenChange, open }) {
  const encodedDestination = encodeURIComponent(destination);
  const googleMapsWebUrl = (
    "https://www.google.com/maps/search/?api=1&query=" + encodedDestination
  );
  const appleMapsWebUrl = (
    "https://maps.apple.com/?daddr=" + encodedDestination + "&dirflg=d"
  );

  const launchNavigation = (provider) => {
    const userAgent = window.navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const webUrl = provider === "google" ? googleMapsWebUrl : appleMapsWebUrl;

    onOpenChange(false);

    if (provider === "google") {
      if (isAndroid) {
        const googleMapsIntent = (
          "intent://maps.google.com/maps?daddr=" + encodedDestination
          + "&dirflg=d#Intent;scheme=https;package=com.google.android.apps.maps;"
          + `S.browser_fallback_url=${encodeURIComponent(webUrl)};end`
        );
        openExternalUrl(googleMapsIntent);
        return;
      }

      if (isIOS) {
        openExternalUrl(
          "comgooglemaps://?daddr=" + encodedDestination + "&directionsmode=driving",
        );
        return;
      }
    }

    if (provider === "apple" && isIOS) {
      openExternalUrl(`maps://?daddr=${encodedDestination}&dirflg=d`);
      return;
    }

    window.open(webUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent
        className="border-gray-200 bg-white"
        data-testid="menu-directions-app-sheet"
        dir="rtl"
        onPointerDownOutside={() => onOpenChange(false)}
      >
        <div className="px-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] pt-4">
          <h2
            className="text-lg font-bold text-gray-900"
            data-testid="menu-directions-app-sheet-title"
          >
            اختر تطبيق الخرائط
          </h2>
          <div className="mt-4 overflow-hidden rounded-xl border border-gray-200">
            <button
              type="button"
              onClick={() => launchNavigation("google")}
              className={
                "flex h-14 w-full items-center justify-between px-4 text-right "
                + "transition-colors duration-200 hover:bg-gray-50"
              }
              data-testid="menu-directions-google-maps-button"
              data-native-url={`google.navigation:q=${destination}`}
              data-web-url={googleMapsWebUrl}
            >
              <span className="flex items-center gap-3">
                <span
                  className="grid h-9 w-9 place-items-center rounded-full bg-blue-50"
                  data-testid="menu-directions-google-maps-icon"
                >
                  <MapPinned size={20} className="text-blue-600" />
                </span>
                <span className="text-sm font-bold text-gray-900">Google Maps</span>
              </span>
              <ArrowLeft size={18} className="text-gray-400" />
            </button>
            <div
              className="h-px w-full bg-gray-200"
              data-testid="menu-directions-apps-divider"
              aria-hidden="true"
            />
            <button
              type="button"
              onClick={() => launchNavigation("apple")}
              className={
                "flex h-14 w-full items-center justify-between px-4 text-right "
                + "transition-colors duration-200 hover:bg-gray-50"
              }
              data-testid="menu-directions-apple-maps-button"
              data-native-url={`maps://?daddr=${encodedDestination}&dirflg=d`}
              data-web-url={appleMapsWebUrl}
            >
              <span className="flex items-center gap-3">
                <span
                  className="grid h-9 w-9 place-items-center rounded-full bg-gray-100"
                  data-testid="menu-directions-apple-maps-icon"
                >
                  <Map size={20} className="text-gray-900" />
                </span>
                <span className="text-sm font-bold text-gray-900">Apple Maps</span>
              </span>
              <ArrowLeft size={18} className="text-gray-400" />
            </button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}